import {
    SignatureVo,
    GetUploadAddressAndCredentialsUsingGetParams,
    GetTranscodeVideoAddressUsingGet1Params,
    TranscodeVideoAddressVo,
    BatchTranscodeVideoAddressParam,
    BatchTranscodeVideoAddressVo
} from '@servicesTypings/companyRequest'
import {
    QueryVideoDetailBySpecialVideoLinkUsingGetParams,
    DouYinBatchUploadVideoSyncSuccess
} from '@servicesTypings/goodsRequest'
import { companyRequest, openCompanyRequest, goodsRequest } from '@/utils/request'

/**
 * 获取OSS临时文件夹签名信息
 */
export function getSignatureInfo(): API.Res<SignatureVo> {
    return companyRequest.get('/aliyun/oss/getSignatureInfo')
}

/**
 * 获取音视频上传地址和凭证
 */
export function getUploadAddressAndCredentials(
    params: GetUploadAddressAndCredentialsUsingGetParams
): API.Res<SignatureVo> {
    return companyRequest.get('/aliyun/video/getUploadAddressAndCredentials', { params })
}

/**
 * 获取转码后的视频地址
 */
export function getTranscodeVideoAddress(
    params: GetTranscodeVideoAddressUsingGet1Params
): API.Res<TranscodeVideoAddressVo> {
    return openCompanyRequest.get('/open/aliyun/video/getTranscodeVideoAddress', { params })
}

/**
 * 批量获取转码后的视频地址
 */
export function batchTranscodeVideoAddress(
    data: BatchTranscodeVideoAddressParam
): API.Res<BatchTranscodeVideoAddressVo> {
    return openCompanyRequest.post('/open/aliyun/video/batchTranscodeVideoAddress', { data })
}

// 获取OSS分享文件夹签名信息
/**
 * 获取OSS永久文件夹签名信息
 */
export function getShareSignature(): API.Res<SignatureVo> {
    return companyRequest.get('/aliyun/oss/getShareSignature')
}

/**
 * 根据特殊视频链接查询视频详情
 */
export function queryVideoDetailBySpecialVideoLink(
    params: QueryVideoDetailBySpecialVideoLinkUsingGetParams
): API.Res<DouYinBatchUploadVideoSyncSuccess> {
    return goodsRequest.get('/platform/video/queryPlatformVideoDetailBySpecialVideoLink', { params })
}
